import {
  HomeOutlined,
  UserOutlined,
  FundOutlined,
  FileProtectOutlined ,
  AuditOutlined,
  ContainerOutlined,
  ToTopOutlined,
  DiffOutlined, 
  UsergroupAddOutlined,
  GroupOutlined,
  HarmonyOSOutlined,
  WalletOutlined,
  MedicineBoxOutlined

   

  // Importa aquí todos los íconos que necesites
} from '@ant-design/icons';

const iconMap: { [key: string]: React.ComponentType } = {
  default: FundOutlined,
  home: HomeOutlined,
  user: UserOutlined,
  business:FileProtectOutlined,
  billing:WalletOutlined,
  plan: FundOutlined,
  plans: FundOutlined,
  planmanagement: FundOutlined,
  plan_management: FundOutlined,
  managementplan: FundOutlined,
  management_plan: FundOutlined,
  subscription: FundOutlined,
  benefit:FundOutlined,
  solicitude:AuditOutlined,
  dashboardcount:HomeOutlined,
  mysolicitude:AuditOutlined,
  patient: UsergroupAddOutlined ,
  steps:AuditOutlined,
  dashboardsolicitude:HomeOutlined,
  claim:ContainerOutlined,
  turn:ToTopOutlined,
  laboratory:DiffOutlined,
  item:DiffOutlined,
  estates:GroupOutlined,
  forum:HarmonyOSOutlined,
  commision:WalletOutlined,
  attention:AuditOutlined,
  speciality: MedicineBoxOutlined,
  specialty: MedicineBoxOutlined,
  specialities: MedicineBoxOutlined,
  specialties: MedicineBoxOutlined,
  section: ContainerOutlined,
  sections: ContainerOutlined,
  medicalrecord: MedicineBoxOutlined,
  medical_record: MedicineBoxOutlined,
  tbcusers: UsergroupAddOutlined,
  tbc_users: UsergroupAddOutlined,
  tbcuser: UsergroupAddOutlined,
  portalusers: UsergroupAddOutlined,
  portal_users: UsergroupAddOutlined,
  usermanagement: UsergroupAddOutlined,
  user_management: UsergroupAddOutlined

  
 


  // Agrega más íconos según sea necesario
};

export default iconMap;
